export const sortByKey = (a: any, b: any, key: string) => {
  if (a[key] < b[key]) return -1;
  else if (a[key] > b[key]) return 1;
  return 0;
};
